var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// In your component file (UsdtFormWithdraw.js)
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import TRC20 from "../../../assets/img/payment/networks/tron.svg";
import BEP20 from "../../../assets/img/payment/networks/bep20.svg";
import POLYGON from "../../../assets/img/payment/networks/polygon-matic-logo.png";
import ERC20 from "../../../assets/img/payment/networks/etherium.svg";
import classNames from "classnames";
import { checkStatusUzdtWallet } from "../../../actions/recharge/creators/usdt";
import Loader from "../../Loader";
import { Field, reduxForm, reset, formValueSelector } from "redux-form";
import { resourceNames } from "../../../constants/accountResourceNames";
import { fetchCryptoData, } from "../../../actions/withdraw/creators/withdraw";
import usdtIcon from "../../../assets/img/footer/usdt.svg";
import { ETH, POL, BNB, TRX, USDT } from "../../../constants/CryptoCurrencies";
var networks = [
    { value: TRX, label: "TRC20", icon: TRC20 },
    { value: ETH, label: "ERC20", icon: ERC20 },
    { value: BNB, label: "BEP20", icon: BEP20 },
    { value: POL, label: "ERC20(Polygon)", icon: POLYGON },
];
var MAX_USDT_AMOUNT = 3000;
var amountSelector = formValueSelector("withdraw-usdt");
var UsdtFormWithdraw = /** @class */ (function (_super) {
    __extends(UsdtFormWithdraw, _super);
    function UsdtFormWithdraw() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            network: networks[0],
            selectedNetwork: false,
        };
        _this.getCurrency = function () {
            var accountResourceId = _this.props.accountResourceId;
            return resourceNames[accountResourceId] || "USD";
        };
        _this.getMinAmount = function () {
            var _a = _this.props, cryptoData = _a.cryptoData, minAmount = _a.minAmount;
            if (cryptoData && cryptoData.MinAmount != null) {
                return cryptoData.MinAmount.toFixed(2);
            }
            return minAmount;
        };
        _this.getMaxAmount = function () {
            var cryptoData = _this.props.cryptoData;
            if (!cryptoData || !cryptoData.Rate) {
                return null;
            }
            return MAX_USDT_AMOUNT * cryptoData.Rate.toFixed(2);
        };
        _this.min = function (value) {
            var minAmount = _this.getMinAmount();
            if (minAmount == null) {
                return undefined;
            }
            if (value && value < Number(minAmount)) {
                return _this.props.intl.formatMessage({
                    id: "withdraw.withdraw_form_min_amount",
                    defaultMessage: "Минимальная сумма вывода - {minAmount} {currency}"
                }, { minAmount: minAmount, currency: _this.getCurrency() });
            }
            return undefined;
        };
        _this.max = function (value) {
            var maxAmount = _this.getMaxAmount();
            if (maxAmount == null) {
                return undefined;
            }
            if (value && value > Number(maxAmount)) {
                return _this.props.intl.formatMessage({
                    id: "withdraw.withdraw_form_max_amount",
                    defaultMessage: "Максимальная сумма вывода - {maxAmount} {currency}"
                }, { maxAmount: maxAmount, currency: _this.getCurrency() });
            }
            return undefined;
        };
        _this.handleSelectNetwork = function (network) {
            var _a = _this.props, reset = _a.reset, fetchCryptoData = _a.fetchCryptoData;
            _this.setState({ network: network, selectedNetwork: true });
            reset("withdraw-usdt");
            // Запрашиваем данные для выбранной сети
            fetchCryptoData(network.value);
        };
        _this.onHandleCopy = function () {
            var el = document.createElement("textarea");
            el.value = _this.props.usdt.get("infoWallet").Address;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        };
        _this.required = function (value) {
            if (!value) {
                return _this.props.intl.formatMessage({
                    id: "validation.required",
                    defaultMessage: "Обязательно"
                });
            }
            return undefined;
        };
        _this.number = function (value) {
            if (value && isNaN(Number(value))) {
                return _this.props.intl.formatMessage({
                    id: "validation.must_be_number",
                    defaultMessage: "Должно быть число"
                });
            }
            return undefined;
        };
        _this.togglePasswordVisibility = function () {
            _this.setState(function (prevState) { return ({
                passwordVisible: !prevState.passwordVisible,
            }); });
        };
        _this.renderAmountField = function (_a) {
            var input = _a.input, placeholder = _a.placeholder, _b = _a.style, style = _b === void 0 ? {} : _b, type = _a.type, _c = _a.meta, touched = _c.touched, error = _c.error, warning = _c.warning;
            var inputCls = touched && error ? "recharge-error" : "";
            return (_jsxs("div", __assign({ className: "input", style: style }, { children: [_jsx("input", __assign({}, input, { value: input.value, placeholder: placeholder, type: "number", className: inputCls })), touched &&
                        ((error && (_jsx("div", __assign({ className: "error-message", style: { color: "red", margin: "5px 0px 0px 5px" } }, { children: error })))) ||
                            (warning && _jsx("span", { children: warning })))] })));
        };
        _this.renderWalletField = function (_a) {
            var input = _a.input, placeholder = _a.placeholder, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.meta, touched = _c.touched, error = _c.error, warning = _c.warning;
            var inputCls = touched && error ? "recharge-error" : "";
            return (_jsxs("div", __assign({ className: "input", style: __assign({ position: "relative" }, style) }, { children: [_jsx("input", __assign({}, input, { placeholder: placeholder, className: inputCls, value: input.value })), _jsx("img", { src: usdtIcon, alt: "USDT", width: 28, height: 28, style: {
                            position: "absolute",
                            right: "5px",
                            top: "5px",
                            // filter: "grayscale(1)",
                        } }), touched &&
                        ((error && (_jsx("div", __assign({ className: "error-message", style: { color: "red", margin: "5px 0px 0px 5px" } }, { children: error })))) ||
                            (warning && _jsx("span", { children: warning })))] })));
        };
        _this.togglePass = function () {
            _this.setState({
                passwordVisible: !_this.state.passwordVisible,
            });
        };
        _this.submitAction = function (values) {
            var submitAction = _this.props.submitAction;
            values["Chain"] = _this.state.network.value;
            values["Currency"] = USDT;
            values["Amount"] = Number(values["Amount"]);
            submitAction(values);
        };
        return _this;
    }
    UsdtFormWithdraw.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fetchCryptoData;
            return __generator(this, function (_a) {
                fetchCryptoData = this.props.fetchCryptoData;
                // Используем сеть по умолчанию (TRC20 = TRX)
                fetchCryptoData(TRX);
                return [2 /*return*/];
            });
        });
    };
    UsdtFormWithdraw.prototype.componentDidUpdate = function (prevProps) {
        var cryptoDataLoaded = prevProps.cryptoData !== this.props.cryptoData && this.props.cryptoData;
        var minAmountChanged = prevProps.minAmount !== this.props.minAmount && this.props.minAmount.toFixed(2) != null;
        if ((cryptoDataLoaded || minAmountChanged) && this.props.amount) {
            this.props.blur("Amount", this.props.amount);
        }
    };
    UsdtFormWithdraw.prototype.render = function () {
        var _this = this;
        var _a = this.props, usdt = _a.usdt, handleSubmit = _a.handleSubmit, intl = _a.intl, fetching = _a.fetching, cryptoData = _a.cryptoData, accountResourceId = _a.accountResourceId;
        var currency = resourceNames[accountResourceId] || "USD";
        // Split the networks array
        var firstThreeNetworks = networks.slice(0, 3);
        var lastNetwork = networks.slice(-1)[0];
        return (_jsxs("div", __assign({ className: "usdt-form" }, { children: [usdt.get("fetching") && _jsx(Loader, {}), _jsxs("div", __assign({ className: "usdt-form__content" }, { children: [_jsxs("div", __assign({ style: { display: "flex", alignItems: "center", gap: "10px" } }, { children: [_jsx("img", { src: usdtIcon, alt: "USDT", width: 28, height: 28 }), _jsxs("h4", { children: [_jsx(FormattedMessage, { id: "withdraw.exchange_rate", defaultMessage: "\u041E\u0431\u043C\u0435\u043D\u043D\u044B\u0439 \u043A\u0443\u0440\u0441" }), ": 1 USDT = ", cryptoData && cryptoData.Rate.toFixed(2), " ", currency] })] })), _jsx("br", {}), _jsxs("form", __assign({ id: "withdraw-usdt", onSubmit: handleSubmit(this.submitAction) }, { children: [_jsx(Field, { placeholder: intl.formatMessage({
                                        id: "withdraw.withdrawal_amount",
                                        defaultMessage: "Сумма снятия (мин. {minAmount} {currency})"
                                    }, { minAmount: cryptoData && cryptoData.MinAmount.toFixed(2), currency: currency }), autoComplete: "off", component: this.renderAmountField, name: "Amount", validate: [this.required, this.number, this.min, this.max] }), _jsx(Field, { placeholder: intl.formatMessage({
                                        id: "withdraw.wallet_number",
                                        defaultMessage: "Номер кошелька"
                                    }), autoComplete: "off", component: this.renderWalletField, name: "Wallet", validate: [this.required] }), _jsxs("div", __assign({ className: "usdt-form__networks" }, { children: [_jsx("p", __assign({ className: "usdt-form__networks_title" }, { children: intl.formatMessage({
                                                id: "withdraw.choose_network",
                                                defaultMessage: "Выберите сеть",
                                            }) })), _jsx("div", __assign({ className: "usdt-form__networks_list" }, { children: firstThreeNetworks.map(function (network) { return (_jsxs("div", __assign({ className: classNames("usdt-form__networks_list_item", {
                                                    active: _this.state.network.value === network.value,
                                                }), onClick: function () { return _this.handleSelectNetwork(network); } }, { children: [_jsx("img", { className: "usdt-form__networks_item_img", src: network.icon, alt: network.label, width: 28, height: 28 }), _jsx("span", __assign({ className: "usdt-form__networks_item_value" }, { children: network.label }))] }), network.value)); }) }))] })), _jsx("div", __assign({ className: "usdt-form__networks" }, { children: _jsx("div", __assign({ className: "usdt-form__networks_list" }, { children: _jsxs("div", __assign({ className: classNames("usdt-form__networks_list_item", {
                                                active: this.state.network.value === lastNetwork.value,
                                            }), onClick: function () { return _this.handleSelectNetwork(lastNetwork); } }, { children: [_jsx("img", { className: "usdt-form__networks_item_img", src: lastNetwork.icon, alt: lastNetwork.label, width: 28, height: 28 }), _jsx("span", __assign({ className: "usdt-form__networks_item_value" }, { children: lastNetwork.label }))] }), lastNetwork.value) })) })), _jsx("div", __assign({ className: "comissionBlock" }, { children: _jsxs("p", { children: [_jsx(FormattedMessage, { id: "withdraw.commission", defaultMessage: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F" }), ": ", _jsx("span", __assign({ style: { fontWeight: 700 } }, { children: cryptoData ? cryptoData.Commission.toFixed(2) : 0 })), " ", currency] }) })), _jsx("br", {}), _jsx("div", __assign({ className: "controls" }, { children: fetching ? (_jsx("button", { disabled: true, className: "loading" })) : (_jsx("button", __assign({ type: "submit" }, { children: _jsx(FormattedMessage, { id: "withdraw.continue", defaultMessage: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C" }) }))) }))] }))] }))] })));
    };
    return UsdtFormWithdraw;
}(React.Component));
UsdtFormWithdraw.propTypes = {
    gamblerId: PropTypes.number.isRequired,
    createWalletUzdtAction: PropTypes.func.isRequired,
    checkStatusUzdtWalletAction: PropTypes.func.isRequired,
    usdt: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    fetchCryptoData: PropTypes.func.isRequired,
    cryptoRate: PropTypes.number,
    minAmount: PropTypes.number,
    cryptoData: PropTypes.object,
    accountResourceId: PropTypes.number,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    blur: PropTypes.func.isRequired,
};
UsdtFormWithdraw = reduxForm({
    form: "withdraw-usdt",
})(UsdtFormWithdraw);
var mapStateToProps = function (state) { return ({
    usdt: state.recharge.get("usdt"),
    cryptoRate: state.withdraw.get("cryptoRate"),
    minAmount: state.withdraw.get("MinAmount"),
    cryptoData: state.withdraw.get("cryptoData"),
    accountResourceId: state.auth.user && state.auth.user.accountResourceId,
    amount: amountSelector(state, "Amount"),
}); };
var mapDispatchToProps = {
    checkStatusUzdtWalletAction: checkStatusUzdtWallet,
    fetchCryptoData: fetchCryptoData,
    reset: reset,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(UsdtFormWithdraw)));



// WEBPACK FOOTER //
// ./src/components/withdraw/forms/UsdtFormWithdraw.jsx